import React, { useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useAppDispatch, useAppSelector } from "../../redux/store";
import {
  setSidebarWidth,
  toggleSidebarCollapse,
} from "../../redux/slice/nonPersist/sidebarSlice";
import { ReactComponent as LeftArrowIcon } from "../../app/assets/icons/leftnav/chevrolet-left.svg";
import { ReactComponent as RightArrowIcon } from "../../app/assets/icons/leftnav/chevrolet-right.svg";
import LeftNav from "../Leftnav/Leftnav";
import LeftnavCollapsed from "../LeftnavCollapsed/LeftnavCollapsed";
import TopNavbar from "../Topnav/Topnav";
import Footer from "../Footer/Footer";
import "./portal-layout.scss";

type LayoutProps = {
  children: React.ReactNode;
  contentWidthSize?: number;
};

export const Layout = ({ children, contentWidthSize = 9 }: LayoutProps) => {
  const dispatch = useAppDispatch();

  const { isCollapsed, sidebarWidth } = useAppSelector(
    (state) => state.sidebar
  );

  const isResizing = useRef(false);

  useEffect(() => {
    localStorage.setItem("sidebarWidth", sidebarWidth.toString());
  }, [sidebarWidth]);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (isResizing.current) {
        const maxSidebarWidth = Math.min(
          window.innerWidth / 2,
          window.innerWidth - 720
        );
        const newWidth = Math.min(
          Math.max(event.clientX, 300),
          maxSidebarWidth
        );

        dispatch(setSidebarWidth(newWidth));
      }
    };

    const handleMouseUp = () => {
      if (isResizing.current) {
        isResizing.current = false;
      }
      document.body.style.userSelect = "";
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    // eslint-disable-next-line
  }, []);

  const handleMouseDown = () => {
    isResizing.current = true;
    document.body.style.userSelect = "none";
  };

  const handleExpandCollapse = (e: React.MouseEvent) => {
    dispatch(toggleSidebarCollapse());

    e.stopPropagation();
  };

  useEffect(() => {
    const topnav = document.getElementById("topnavmenu");
    const footer = document.getElementById("footer");
    const customeMessage = document.getElementById(
      "custom-notification-message"
    );

    if (!topnav || !footer) return;

    const updateHeight = () => {
      const topnavHeight = topnav.offsetHeight || 0;
      const footerHeight = footer.offsetHeight || 0;
      const customeMessageHeight = customeMessage?.offsetHeight || 0;
      const totalOffset = topnavHeight + footerHeight + customeMessageHeight;

      document.documentElement.style.setProperty(
        "--total-offset",
        `${totalOffset}px`
      );
      document.documentElement.style.setProperty(
        "--total-offset-mobile",
        `${totalOffset + 34.64}px`
      );
    };

    const observer = new MutationObserver(updateHeight);
    observer.observe(topnav, {
      childList: true,
      subtree: true,
      attributes: true,
    });
    observer.observe(footer, {
      childList: true,
      subtree: true,
      attributes: true,
    });
    // if the height is not including the custom message block height, add its observer as well in future if needed

    updateHeight();

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <TopNavbar />
      <Row
        className="mx-0 content-layout"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
        }}
      >
        <div
          className="d-none d-lg-flex px-2 pt-3"
          style={{
            width: isCollapsed ? "100px" : `${sidebarWidth}px`,
            flexDirection: "column",
            borderRight: "1px solid #dee2e6",
            position: "relative",
            transition: "width 0.3s",
            backgroundColor: "#f8f5f0",
            zIndex: 2,
          }}
        >
          <>
            {" "}
            <Col
              className={`${isCollapsed ? "me-0 ps-2 py-2" : "me-2 p-2"}`}
              id="sidebar-wrapper"
              style={{
                height: "100%",
                overflow: "auto",
                display: "block",
                scrollbarWidth: "thin",
                // zIndex: 2,
              }}
            >
              {!isCollapsed ? <LeftNav /> : <LeftnavCollapsed />}
            </Col>
            <div
              style={{
                backgroundColor: "rgb(248, 245, 240)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "16px",
                fontWeight: 400,
                color: "#000000",
                lineHeight: "14px",
              }}
            >
              vX.X.X
            </div>
            {!isCollapsed && (
              <div
                onMouseDown={handleMouseDown}
                style={{
                  width: "3px",
                  cursor: "col-resize",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "#f1f1f1",
                  // zIndex: 2,
                }}
              />
            )}
          </>

          {/* <TooltipContainer id="tooltip-expand-collapse" place="right"> */}
          <div
            className="expand-icon"
            onClick={handleExpandCollapse}
            style={{
              position: "absolute",
              left: isCollapsed ? "88px" : `${Number(sidebarWidth) - 12}px`,
              top: "20px",
              transition: "left 0.3s",
            }}
          >
            {isCollapsed ? (
              <RightArrowIcon
                data-tooltip-html={"Expand"}
                data-tooltip-id="tooltip-expand-collapse"
                style={{ outline: "none" }}
              />
            ) : (
              <LeftArrowIcon
                data-tooltip-html={"Collapse"}
                data-tooltip-id="tooltip-expand-collapse"
                style={{ outline: "none" }}
              />
            )}
          </div>
          {/* </TooltipContainer> */}
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "clip overlay",
          }}
        >
          <Col
            className="contenttttt"
            id="page-content-wrapper"
            style={{ flex: 1 }}
          >
            <Container fluid className="mt-4">
              {children}
            </Container>
          </Col>
        </div>
      </Row>
      <Footer />
    </>
  );
};
